const testData = {
	// 商标地区分布
	leftTop: {
		title: '商标地区分布',
		yData: [
			// { value: 1045599, name: '广东省' },
			// { value: 480206, name: '浙江省' },
			// { value: 420635, name: '北京市' },
			// { value: 351347, name: '上海市' },
			// { value: 347312, name: '江苏省' },
			// { value: 4452507, name: '其他' }
		]
	},

	// 企业数据
	leftCenter: {
		title: '企业数据',
		id: 'divLeftCenter',
		xData: ['广东省', '浙江省', '江苏省', '山东省', '上海市', '北京市', '福建省', '河南省', '四川省', '河北省'],
		yData: [173671, 76473, 64691, 59828, 51982, 49553, 42331, 34288, 30227, 28673]
	},

	// 行业分布
	leftBottom: {
		title: '行业分布',
		xData: ['其他', '批发业', '零售业', '商务服务业', '科技推广和应用服务业'],
		yData: [2684054, 999142, 587055, 439392, 422012]
	},

	// 商标类别排名
	rightTop: {
		title: '产业分布',
		xData: ['为商品和服务的买卖...','特许经营的商业管理','市场营销','替他人推销', '广告',],
		yData: [5, 4, 3, 2, 1].map(i=>100 / i + 100)
	},

	// 产业分布
	rightCenter: {
		title: '商标类别排名',
		xData: ['35广告销售', '30方便食品', '25服装鞋帽', '09科学仪器','43餐饮住宿'],
		yData: [955948, 457990, 389766, 368675, 334961]

	},
	rightBottom:{
		title: '成功率趋势',
		xData: ['广东省', '浙江省', '江苏省', '山东省', '上海市', '北京市', '福建省', '河南省', '四川省', '河北省'],
		yData: [173671, 76473, 64691, 59828, 51982, 49553, 42331, 34288, 30227, 28673]
	},

	map: [
		{ name: '海南', value: 45881 },
		{ name: '澳门', value: 880 },
		{ name: '吉林', value: 43233 },
		{ name: '安徽', value: 160312 },
		{ name: '新疆', value: 58374 },
		{ name: '宁夏', value: 15420 },
		{ name: '陕西', value: 99835 },
		{ name: '天津', value: 54580 },
		{ name: '湖北', value: 119040 },
		{ name: '山西', value: 52845 },
		{ name: '西藏', value: 10474 },
		{ name: '福建', value: 300197 },
		{ name: '广东', value: 1045599 },
		{ name: '山东', value: 314274 },
		{ name: '黑龙江', value: 53511 },
		{ name: '湖南', value: 169352 },
		{ name: '上海', value: 351347 },
		{ name: '辽宁', value: 73533 },
		{ name: '浙江', value: 480206 },
		{ name: '北京', value: 420635 },
		{ name: '青海', value: 9746 },
		{ name: '江苏', value: 347312 },
		{ name: '广西', value: 70293 },
		{ name: '甘肃', value: 25499 },
		{ name: '台湾', value: 4669 },
		{ name: '江西', value: 96610 },
		{ name: '河南', value: 231412 },
		{ name: '内蒙古', value: 44185 },
		{ name: '重庆', value: 97720 },
		{ name: '香港', value: 53137 },
		{ name: '贵州', value: 95077 },
		{ name: '河北', value: 151723 },
		{ name: '四川', value: 208003 },
		{ name: '云南', value: 83383 }
	],

	log: () =>
		new Date().toLocaleString() +
		[
			' 发现工控漏洞信息23条',
			' 新发现僵尸设备16个',
			' 新发现漏洞设备8个',
			' 新发现僵尸设备98个',
			' 新发现漏洞设备12个',
			' 新发现漏洞设备23个'
		][Math.floor(Math.random() * 6)] +
		'<br>'
}

export function getData(name, label) {
	const data = typeof testData[name] == 'function' ? testData[name]() : testData[name]
	if (label) {
		return Object.assign(data, testData.selectChooseData[name][label])
	} else {
		return data
	}
}

export function getLabels(name) {
	return testData.selectData[name]
}
